export default __webpack_public_path__ + "static/media/calender.3d321bcf.svg";